export default "__VITE_ASSET__6f80df36__"